import React from "react";
import ClientFooter from "./ClientFooter";

const TradingRiskDisclaimer = () => {
    return (
        <>
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">Trading Risk Disclaimer</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="index.html">Home</a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">Trading Risk Disclaimer</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rbt-overlay-page-wrapper">
                <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapBottom">
                    <div className="rbt-article-content-wrapper">
                        <div className="content mt-5">
                            <h4>Trading Risk Disclaimer – Day Trading Tactics</h4>

                            <div className="mb-4">
                                <p><strong>Company Name:</strong> Day Trading Tactics</p>
                                <p><strong>Effective Date:</strong> 11/05/2025</p>
                                <p><strong>Location:</strong> Mogappair, Chennai, India</p>
                                <p><strong>Contact Email:</strong> venkateshan@daytradingtactics.in</p>
                            </div>

                            <h4>General Disclaimer</h4>
                            <p className="mb-4">
                                All content provided by <b>Day Trading Tactics</b> — including live sessions, recorded video lessons, webinars, downloadable materials, and related educational resources — is strictly for educational and informational purposes only.<br />
                                We do not provide investment advice, brokerage services, or financial advisory under SEBI regulations.
                            </p>

                            <h4>Market Risk Awareness</h4>
                            <p className="mb-3">
                                Trading in financial markets (including stocks, options, futures, and index) involves significant risk. Prices can move quickly, and there is no guarantee of profits. By participating in any of our programs or content:
                            </p>
                            <ul className="mb-4">
                                <li>You accept full responsibility for your trading decisions.</li>
                                <li>You acknowledge that trading may result in partial or total loss of capital.</li>
                                <li>You understand that past performance shown in examples or case studies does not guarantee future results.</li>
                            </ul>

                            <h4>No Investment Advice</h4>
                            <p className="mb-4">
                                Although our sessions may refer to trading strategies, patterns, or setups, nothing shared by <b>Day Trading Tactics</b> should be considered as personal investment advice. Our instructors are educators — not SEBI-registered advisors or portfolio managers.<br />
                                We do not make recommendations to buy, sell, or hold any securities.
                            </p>

                            <h4>Live Sessions Disclaimer</h4>
                            <p className="mb-3">During live market sessions or webinars:</p>
                            <ul className="mb-4">
                                <li>All trades or observations are made for demonstration purposes only.</li>
                                <li>Any trades discussed are for illustration and educational discussion.</li>
                                <li>We are not responsible for how you use this information in your personal trading account.</li>
                                <li>You are expected to consult with your financial advisor or do your own research before making real trades.</li>
                            </ul>

                            <h4>Legal Protection</h4>
                            <p className="mb-4">
                                By using our website, courses, or attending live sessions, you agree that:<br />
                                <b>Day Trading Tactics</b>, its team, partners, or instructors are not liable for any direct or indirect loss or damage from the use of our content.<br />
                                You use our platform and tools at your own risk.<br />
                                This disclaimer is governed by the laws of India, under the jurisdiction of courts located in Chennai, Tamil Nadu.
                            </p>

                            <h4>Final Word</h4>
                            <p className="mb-3">
                                Trading is not easy or risk-free. We are here to educate, not to guarantee profits.<br />
                                If you're unsure about whether trading is right for you, we recommend:
                            </p>
                            <ul className="mb-4">
                                <li>Speaking to a certified financial advisor.</li>
                                <li>Practicing with paper trades before investing real money.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default TradingRiskDisclaimer; 